// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"614":"9cb1c71391b644da","9337":"a231067771058fa1"}[chunkId] + ".css";
};